<template>
  <layout :title-text="title">
    <div slot="content" class="contact-container">
      <div class="article" v-for="(item, index) in contactList" :key="index">
        <img :src="item.imgSrc" draggable="false">
        <div class="text-content">
          <h2>{{ item.contactTitle }}</h2>
          <span>{{ item.contactText }}</span>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
import iconEmail from '../../assets/images/icon_email.png'
import iconQQ from '../../assets/images/icon_QQ.png'
import iconTel from '../../assets/images/icon_tel.png'
export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '联系方式',
      contactList: [
        {
          imgSrc: iconEmail,
          contactTitle: '大赛组委会报名邮箱',
          contactText: 'lanmaobei@126.com'
        },
        {
          imgSrc: iconQQ,
          contactTitle: '蓝帽杯比赛QQ交流群',
          contactText: '725196415'
        },
        {
          imgSrc: iconTel,
          contactTitle: '大赛组委会联系电话',
          contactText: '15611116521'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.contact-container {
  position: relative;
  margin: 0 auto;
  width: 1100px;
  height: 150px;
  padding-left: 70px;
  display: flex;
  justify-content: space-between;
  .article {
    flex: 1;
    img {
      width: 99px;
      height: 107px;
      float: left;
      display: block;
    }
    h2 {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #D1A341;
      margin-bottom: 15px;
    }
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #5891FA;
    }
    .text-content {
      padding-left: 10px;
      float: left;
      text-align: left;
      height: 88px;
    }
    &:after{
        content: '';
        clear: both;
        display: block;
    }
  }
}
</style>
